import { createFileRoute } from '@tanstack/react-router';
import { ensureOBSPresence } from '../../../../utils/ensureOBSPresence';

import { InputSourcePropertiesSelect } from '../../../../types/obs';
import { UnsupportedOBSVersion } from '../../../../components/UnsupportedOBSVersion';
import { Badge, Text } from '@streamelements/frontend-ui';
import { InputSourcePropertiesClientProvider } from '../-InputSourcePropertiesAdapter';

export const Route = createFileRoute('/_authenticated/onboarding/new-setup/_layout/')({
  component: () => <div></div>,
  errorComponent: () => (
    <UnsupportedOBSVersion>
      <Text.Body css={{ mt: '1rem', color: '$textPrimary70', mb: '0.25rem' }}>Missing methods:</Text.Body>

      <Badge
        appearance="translucent"
        css={{
          $$colorBackground: '$colors$uiAttention25',
          $$colorText: '$colors$uiAttention75',
          boxShadow: 'none',
          textTransform: 'none',
          fontSize: '$caption',
        }}
      >
        getInputSourceProperties
      </Badge>
    </UnsupportedOBSVersion>
  ),
  loader: async () => {
    await ensureOBSPresence();

    if (!window.host.getInputSourceProperties) {
      throw new Error('Unsupported SE.Live version. Missing method: getInputSourceProperties');
    }

    const sourcePropertiesClient = await InputSourcePropertiesClientProvider.createSourcePropertiesClient();
    const audioInputSourceType = await sourcePropertiesClient.getAudioInputSourceType();
    const videoInputSourceType = await sourcePropertiesClient.getVideoInputSourceType();

    console.log({
      sourcePropertiesClient,
      audioInputSourceType,
      videoInputSourceType,
    });

    const { audioInputIdPropertyName, videoInputIdPropertyName } = sourcePropertiesClient;

    const audioInputOptions = audioInputSourceType.properties.find(
      (prop) => prop.name === audioInputIdPropertyName
    ) as InputSourcePropertiesSelect;

    const videoInputOptions = videoInputSourceType.properties.find(
      (prop) => prop.name === videoInputIdPropertyName
    ) as InputSourcePropertiesSelect;

    return {
      audioInputOptions,
      videoInputOptions,
    };
  },
});
